import { ClientEvent } from '@udemy/event-tracking';

/** This event is fired when an academy card is presented to the user. */
export class AcademyPresented extends ClientEvent {
  constructor({
    academySlug,
    uiRegion
  }) {
    super('AcademyPresented');
    this.academySlug = void 0;
    this.uiRegion = void 0;
    this.academySlug = academySlug;
    this.uiRegion = uiRegion;
  }
}

/** This event is fired when an academy card is selected by the user. */
export class AcademySelected extends ClientEvent {
  constructor({
    academySlug,
    uiRegion
  }) {
    super('AcademySelected');
    this.academySlug = void 0;
    this.uiRegion = void 0;
    this.academySlug = academySlug;
    this.uiRegion = uiRegion;
  }
}
//# sourceMappingURL=events.js.map